import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Download, Copy, Trash2 } from "lucide-react";
import { useApi, errMsg, fmtDate } from "@/lib/api";
import { PageHeader, Empty } from "@/components/portal/StatusBadge";

export default function Newsletter() {
  const api = useApi();
  const [subs, setSubs] = useState(null);
  useEffect(() => {
    api("get", "/newsletter").then(setSubs);
  }, [api]);

  const exportCsv = () => {
    const csv = "email,name,subscribed\n" + subs.map((s) => `${s.email},${(s.name || "").replace(/,/g, " ")},${s.created_at}`).join("\n");
    const a = document.createElement("a");
    a.href = URL.createObjectURL(new Blob([csv], { type: "text/csv" }));
    a.download = "newsletter-subscribers.csv";
    a.click();
  };
  const copyAll = async () => {
    await navigator.clipboard.writeText(subs.map((s) => s.email).join(", "));
    toast.success("Emails copied — paste into the BCC field of your email");
  };
  const remove = async (s) => {
    try {
      await api("delete", `/newsletter/${s.id}`);
      setSubs(subs.filter((x) => x.id !== s.id));
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <div data-testid="newsletter-page">
      <PageHeader eyebrow="Website signups" title="Newsletter subscribers">
        {subs?.length > 0 && (
          <>
            <button onClick={copyAll} data-testid="newsletter-copy-btn" className="inline-flex items-center gap-2 rounded-full border border-[#0E1F3F] px-4 py-2 text-sm font-semibold hover:bg-[#0E1F3F] hover:text-white"><Copy size={14} />Copy emails</button>
            <button onClick={exportCsv} data-testid="newsletter-export-btn" className="inline-flex items-center gap-2 rounded-full bg-[#F2B91C] px-4 py-2 text-sm font-bold text-[#0E1F3F] hover:bg-[#D9A30F]"><Download size={14} />Export CSV</button>
          </>
        )}
      </PageHeader>
      <p className="mb-6 max-w-2xl text-sm text-[#5C5850]">People who joined from the website footer. Export the list to your newsletter tool (e.g. Mailchimp) or copy the emails into the BCC field when you send your update.</p>
      {subs && !subs.length && <Empty text="No subscribers yet." />}
      <div className="divide-y rounded-2xl border border-[#E6E2DA] bg-white">
        {subs?.map((s) => (
          <div key={s.id} className="flex items-center justify-between px-5 py-3" data-testid={`subscriber-${s.id}`}>
            <div><p className="font-medium">{s.email}</p><p className="text-xs text-[#8C877D]">Joined {fmtDate(s.created_at)}</p></div>
            <button onClick={() => remove(s)} data-testid={`subscriber-delete-${s.id}`} className="text-[#8C877D] hover:text-red-600"><Trash2 size={15} /></button>
          </div>
        ))}
      </div>
    </div>
  );
}
